// extracted by mini-css-extract-plugin
export default {"illustration":"_4Yg1ngI+zJVOfkXojsx4wg==","otpAnimation":"itPX1XQp6iRiBGsBLUKjoQ==","illustrationWrap":"_5F81N5NDXcwjGliCnQQChQ=="};